var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info-octagon",
    clipPath: "url(#clip0_1271_2066)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M8.00065 10.6673V8.00065M8.00065 5.33398H8.00732M1.33398 5.68248V10.3188C1.33398 10.4819 1.33398 10.5634 1.3524 10.6401C1.36874 10.7082 1.39567 10.7732 1.43222 10.8328C1.47345 10.9001 1.5311 10.9578 1.6464 11.0731L4.92823 14.3549C5.04353 14.4702 5.10118 14.5279 5.16846 14.5691C5.22811 14.6056 5.29314 14.6326 5.36116 14.6489C5.43789 14.6673 5.51942 14.6673 5.68248 14.6673H10.3188C10.4819 14.6673 10.5634 14.6673 10.6401 14.6489C10.7082 14.6326 10.7732 14.6056 10.8328 14.5691C10.9001 14.5279 10.9578 14.4702 11.0731 14.3549L14.3549 11.0731C14.4702 10.9578 14.5279 10.9001 14.5691 10.8328C14.6056 10.7732 14.6326 10.7082 14.6489 10.6401C14.6673 10.5634 14.6673 10.4819 14.6673 10.3188V5.68248C14.6673 5.51942 14.6673 5.43789 14.6489 5.36116C14.6326 5.29314 14.6056 5.22811 14.5691 5.16846C14.5279 5.10118 14.4702 5.04353 14.3549 4.92823L11.0731 1.6464C10.9578 1.5311 10.9001 1.47345 10.8328 1.43222C10.7732 1.39567 10.7082 1.36874 10.6401 1.3524C10.5634 1.33398 10.4819 1.33398 10.3188 1.33398H5.68248C5.51942 1.33398 5.43789 1.33398 5.36116 1.3524C5.29314 1.36874 5.22811 1.39567 5.16846 1.43222C5.10118 1.47345 5.04353 1.5311 4.92823 1.6464L1.6464 4.92823C1.5311 5.04353 1.47345 5.10118 1.43222 5.16846C1.39567 5.22811 1.36874 5.29314 1.3524 5.36116C1.33398 5.43789 1.33398 5.51942 1.33398 5.68248Z",
    stroke: "#01588C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_2066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d377a37a549b2dc283b77ef881758307.svg";
export { ForwardRef as ReactComponent };